// The keys mirror the names of the backend enum VytalUtilities.LanguageHeaderValue
// and are used as the NamesByLanguage keys everywhere the values are read.
// `Do` is intentionally left out: it exists in the backend enum but is not a
// language anyone can maintain, so it is never rendered or written.
export const UserLanguage = {
  De: 'De',
  En: 'En',
  Fr: 'Fr',
  Nl: 'Nl',
  Nb: 'Nb',
  Et: 'Et',
  EsMx: 'EsMx',
  Lb: 'Lb',
  Pt: 'Pt',
  Sv: 'Sv',
  Pl: 'Pl',
  Hu: 'Hu',
  Da: 'Da',
  No: 'No',
  Al: 'Al',
  El: 'El',
  Ca: 'Ca',
  Eu: 'Eu',
  Gl: 'Gl',
};

// Ordinals of VytalUtilities.LanguageHeaderValue. These are sent as the
// NamesByLanguage keys when saving, so every entry MUST keep matching the
// ordinal of the enum member with the same name — when a language is appended to
// the enum, append it here too. A drifting entry silently writes a name into a
// different language's slot (that is how Al/El/Ca/Eu/Gl ended up shifted by one
// after `Da` and `No` were added to the enum in 2024).
export const IdByUserLanguage: { [key: string]: number } = {
  De: 0,
  En: 1,
  Fr: 2,
  Nl: 3,
  Nb: 4,
  Et: 5,
  EsMx: 6,
  Lb: 7,
  Pt: 8,
  Sv: 9,
  Do: 10,
  Pl: 11,
  Hu: 12,
  Da: 13,
  No: 14,
  Al: 15,
  El: 16,
  Ca: 17,
  Eu: 18,
  Gl: 19,
};

export function expandNamesByLanguage(translatable: {
  namesByLanguage: { [x: string]: string };
  internalName: string;
}) {
  const namesByLanguage: { [lang: string]: string } = {
    ...translatable.namesByLanguage,
  };
  for (const key of Object.keys(UserLanguage)) {
    if ((translatable.namesByLanguage || {})[key] == null) {
      if ((translatable.namesByLanguage || {})[UserLanguage.En] != null) {
        namesByLanguage[key] = translatable.namesByLanguage[UserLanguage.En];
      } else if (
        (translatable.namesByLanguage || {})[UserLanguage.De] != null
      ) {
        namesByLanguage[key] = translatable.namesByLanguage[UserLanguage.De];
      } else {
        namesByLanguage[key] = translatable.internalName;
      }
    }
  }

  return {
    ...translatable,
    namesByLanguage,
  };
}

export const getDefaultNamesByLanguageObject = (name: string) => {
  const namesByLanguage: { [lang: string]: string } = {};
  for (const key of Object.keys(UserLanguage)) {
    namesByLanguage[key] = name;
  }
  return namesByLanguage;
};
